export interface Complaint {
  title: string;
  duration?: {
    value?: number;
    unit?: string;
  };
  description?: string;
  favorite?: boolean;
}

export interface ComplaintSuggestionResponse {
  title: string;
  favorite: boolean;
}

export interface ComplaintSuggestion extends ComplaintSuggestionResponse {
  selected: boolean;
}

export enum ComplaintSearchItemTypes {
  cid10 = 'Tabela CID 10',
  most_used = 'Mais utilizadas por você',
}

export interface ComplaintSearchItem {
  title: string;
  type: string;
  favorite: boolean;
}

export interface ComplaintSearchResponse {
  most_used: {
    favorite: boolean;
    title: string;
  }[];
  cid10: string[];
}
